import Variable from '../../constants/constants.json';

const { handleExcception } = require('../../api/sentryExceptionHandler');
const { GET_INCIDENT } = require('../Constants/incident.constants');
const { createRequest } = require('../../api/client');

export const getIncidents = (data) => async (dispatch) => {
    const options = {
        url: `${Variable.backendUrl}/incidents/getIncidents`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: {
            tenantId: data.tenantId,
            sort: data.sort,
            pageNo: data.pageNo,
            resultsPerPage: data.resultsPerPage,
            status: data.status,
            startDate: new Date(data.startDate),
            endDate: new Date(data.endDate),
            searchString: data.searchString
        }
    };
    try {
        const data = await createRequest(options);
        dispatch({
            type: GET_INCIDENT,
            data
        });
    } catch (err) {
        handleExcception(err);
        dispatch({
            type: GET_INCIDENT,
            data: {}
        });
    }
};

export const saveIncident = (data) => async () => {
    const options = {
        url: `${Variable.backendUrl}/incidents/saveIncident`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: data
    };
    try {
        await createRequest(options);
        return null;
    } catch (err) {
        handleExcception(err);
        return null;
    }
};

export const getIncidentsToExport = (data) => async () => {
    const options = {
        url: `${Variable.backendUrl}/incidents/getIncidents`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: {
            tenantId: data.tenantId,
            sort: data.sort,
            status: data.status,
            startDate: new Date(data.startDate),
            endDate: new Date(data.endDate),
            searchString: data.searchString
        }
    };
    try {
        const data = await createRequest(options);
        // dispatch({
        //     type: EXPORT_INCIDENT,
        //     data
        // });
        return data;
    } catch (err) {
        handleExcception(err);
        return null;
    }
};

export const getClientViewIncidents = async (data) => {
    if (data.status === 'past') {
        data.status = ['Resolved'];
    } else {
        data.status = ['Identified', 'Investigating', 'Monitoring'];
    }
    const options = {
        url: `${Variable.backendUrl}/incidents/getIncidents`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: {
            searchString: data.searchString,
            tenantId: data.tenantId,
            sort: -1,
            pageNo: data.pageNo,
            resultsPerPage: data.resultsPerPage,
            status: data.status
        }
    };
    try {
        const data = await createRequest(options);
        return data;
    } catch (err) {
        handleExcception(err);
        throw new Error(err);
    }
};

export const deleteIncident = async (id) => {
    const options = {
        url: `${Variable.backendUrl}/incidents/deleteIncident?id=${id}`,
        method: 'DELETE'
    };
    try {
        const data = await createRequest(options);
        return data;
    } catch (err) {
        handleExcception(err);
        throw new Error(err);
    }
};
